import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22call-booking.tsx%22,%22import%22:%22Jersey_25%22,%22arguments%22:[{%22weight%22:%22400%22,%22subsets%22:[%22latin%22]}],%22variableName%22:%22fontFamily%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Jersey 25', 'Jersey 25 Fallback'",
        fontWeight: 400,
fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
